/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingHistory } from '../../models/onboarding-history';
import { OnboardingResource } from '../../models/onboarding-resource';

export interface GetUserOnboardingGrantHistory$Params {

/**
 * The user uid
 */
  userUid: string;

/**
 * restrict histories requested to this resource type
 */
  resourceFilter?: OnboardingResource;
}

export function getUserOnboardingGrantHistory(http: HttpClient, rootUrl: string, params: GetUserOnboardingGrantHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingHistory>>> {
  const rb = new RequestBuilder(rootUrl, getUserOnboardingGrantHistory.PATH, 'get');
  if (params) {
    rb.path('userUid', params.userUid, {});
    rb.query('resourceFilter', params.resourceFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OnboardingHistory>>;
    })
  );
}

getUserOnboardingGrantHistory.PATH = '/custom/onboarding/user/{userUid}/history';
